<template lang="pug">
  app-page(:fab-items="fabItems" title="Мои файлы" @search="text => (search = text.toLowerCase())" :loading="loading")
    v-row(no-gutters)
      .col-3      
        file-store-explorer

      .col-9.pl-2
        file-store-toolbar.mb-2

        .text-right
          v-chip.ma-2(v-if="search" color="#757575" text-color="white" small label close @click:close="search = null") Поиск:&nbsp;<b>{{ search }}</b>
          v-chip.ma-2(v-if="period" color="#757575" text-color="white" small label close @click:close="setPeriod(null)") Период:&nbsp;<b>{{ period.text }}</b>
          v-chip.ma-2(v-if="filterTag" color="#757575" text-color="white" small label close @click:close="setFilterTag(null)") Тег:&nbsp;<b>"{{ filterTag.hashtag }}"</b>

        app-group-animation.mx-n1
          app-group-item.px-1(v-for="(f, index) in visibleFiles" :key="f.id" cols="4")
            file-store-file(:file="f" :highlight-text="search" @click.native="$refs.dialogManageFile.show(f)")
    
    dialog-manage-file(v-model="dialog.manageFile" ref="dialogManageFile")
    dialog-new-folder(v-model="dialog.newFolder" ref="dialogNewFolder")
    dialog-new-file(v-model="dialog.newFile" ref="dialogNewFile")
</template>

<script>
import { mapMutations, mapState, mapGetters } from 'vuex'
import moment from '@/common/AppMoment.js'

import explorer from './components/FileStoreExplorer'
import file from "./components/FileStoreFile"
import toolbar from "./components/FileStoreToolbar"
import dialogNewFolder from "./components/FileStoreDialogNewFolder"
import dialogNewFile from "./components/FileStoreDialogNewFile"
import dialogManageFile from "./components/FileStoreDialogManageFile"

import { syncService } from "@/_services"

export default {
  components: {
    [explorer.name]: explorer,
    [file.name]: file,
    [toolbar.name]: toolbar,
    dialogNewFolder,
    dialogNewFile,
    dialogManageFile
  },

  mounted () {
    this.$store.dispatch('fileStore/init')
  },

  computed: {
    ...mapState('fileStore', ['filterTag', 'sorter', 'period', 'path']),
    ...mapGetters('fileStore', ['documentsByPath', 'templatesByPath']),
    ...mapGetters('judge', ['JUDGE']),

    visibleFiles () {
      let list = this.path.isTag ? this.templatesByPath(this.path) : this.documentsByPath(this.path)

      if (this.search) {
        list = list.filter(f => f.name.toLowerCase().includes(this.search))
      }

      if (this.filterTag) {
        list = list.filter(f => f.tags.findIndex(t => t.id == this.filterTag.id) != -1)
      }
      if (this.period) {
        list = list.filter(item => moment(item.date).isBetween(this.period.start, this.period.end, 'day', '[]'))
      }
      
      list.sort((a, b) => b[this.sorter.key].localeCompare(a[this.sorter.key]) || b.id.localeCompare(a.id))
      return list
    },

    fabItems () {
      return [
        { icon: 'create_new_folder', title: 'Новая папка', action: () => this.$refs.dialogNewFolder.show() },
        { icon: 'insert_drive_file', title: 'Новый файл', action: () => this.$refs.dialogNewFile.show() },
        { icon: 'sync', title: 'Синхронизация шаблонов', action: () => this.syncTemplatesJudge() },
      ]
    },
  },

  methods: {
    ...mapMutations('fileStore', ['setPeriod', 'setFilterTag']),

    syncTemplatesJudge () {
      this.loading = true
      syncService.syncTemplates(this.JUDGE.id).then(() => {
        this.$store.dispatch('fileStore/getTemplates')
        this.loading = false
      })
    }
  },

  data () {
    return {
      dialog: {
        newFolder: false,
        newFile: false,
        manageFile: false
      },
      search: null,
      loading: false
    }
  }
}
</script>